import { UnstyledButton } from '@shared/ui/unstyled-button';
import { XMarkSolidIcon } from '@shared/assets/icons';
import * as stylex from '@stylexjs/stylex';
import { styles } from './styles';
import { ReactNode } from 'react';

interface ChipProps {
  onDelete: (e: React.MouseEvent<HTMLButtonElement>) => void;
  children: ReactNode;
  variant?: 'default' | 'brandGhost' | 'counter';
}

export const Chip = ({ children, onDelete, variant = 'default' }: ChipProps) => {
  return (
    <div {...stylex.props(styles.chip, variant === 'brandGhost' && styles.chipBrandGhost)}>
      <div {...stylex.props(styles.chipContent, variant === 'counter' && styles.chipContentCounterPadding)}>
        {children}

        <UnstyledButton {...stylex.props(styles.deleteButton)} onClick={(e) => onDelete(e)}>
          <XMarkSolidIcon color="currentColor" />
        </UnstyledButton>
      </div>
    </div>
  );
};
